import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonCheckbox from '../components/CommonCheckbox';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchEB01DataCourse extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { th_name, keyword, academy_id, benefits_id, enterprise_id, target_industries_id, target_group, official_course_code, status, self_course_types, course_type } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">               
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{th_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={th_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{academy_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={academy_id}
                                        option={{source: 'db', data: Masterbase?.academy}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!['0','1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>                    
                                {/** 
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{keyword.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={keyword}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                                */}
                            </Col>  
                        </Row>

                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{enterprise_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={enterprise_id}
                                        option={{source: 'db', data: Masterbase?.enterprise}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>   
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{benefits_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={benefits_id}
                                        option={{source: 'db', data: Masterbase?.benefits}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                                     
                        </Row>

                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{target_industries_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={target_industries_id}
                                        option={{source: 'db', data: Masterbase?.target_industries}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>   
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{target_group.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={target_group}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                                     
                        </Row>

                        <Row>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{official_course_code.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={official_course_code}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>                                 
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{course_type.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={course_type}
                                        option={{source: 'options', section: 'course_type', item: 'default'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!['0','1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>  
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'eb01_course_approve_status'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                            <Col md={6}>
                                <div className="mt-2">
                                    <InputGroup className="mb-3">
                                        <CommonCheckbox
                                            element="Searchs"
                                            input={Searchs}
                                            checkbox={InputGroups.Checkbox.search_eec_hdc}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </InputGroup>
                                </div>
                            </Col> 
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchEB01DataCourse;